export const GET_REFFERAL_DATA = "GET_REFFERAL_DATA"
export const GET_WALLET_HISTORY = "GET_WALLET_HISTORY"
export const GET_ViDEOS = "GET_ViDEOS"